import { Time } from 'types/general.types';
import { Link } from 'types/api.types';
import { MultiItemResponse, SingleItemResponse } from 'types/generic.types';
import { ShareType } from 'app/components/Shares/types';
import { AudioPlayerAudioInstance } from 'app/store/AudioPlayer/slice.types';
import { PlaylistImage } from 'types/playlists.types';
import { AudioStatusType } from './audio/audio.types';

export enum LinkStatus {
  REVOKED = 'REVOKED',
  ACTIVE = 'ACTIVE',
}

export interface Shares {
  created: Time;
  updated: Time;
  guid: string;
}

export interface SharedLink extends Shares {
  downloadable: boolean;
  creditsShared: boolean;
  lyricsShared: boolean;
  href: string;
  shareLink: string;
  status: LinkStatus;
  title: string;
  _links: {
    revokeShare?: Link;
    updateShare?: Link;
  };
}

export interface _SharedLinks {
  next?: Link;
  createShare?: Link;
}

export type GetSharedLinksResponse = MultiItemResponse<
  SharedLink,
  'share',
  _SharedLinks
>;

export interface SharedPlaylist {
  guid: string;
  title: string;
  description: string;
  author: string;
  queue: AudioPlayerAudioInstance[];
  referralId?: string;
  images: PlaylistImage[];
  _links: {
    getMobileWaveform: Link;
    getDesktopWaveform: Link;
    playAudio: Link;
    downloadAudio?: Link;
    contributions?: Link;
    lyrics?: Link;
  };
}

export interface SharedPlaylistResponseShare {
  type: ShareType;
  createdBy: {
    profileCard: {
      displayName: string;
    };
  };
  shareToken: string;
  _links: {
    downloadAudio?: Link;
    contributions?: Link;
    lyrics?: Link;
  };
}

interface SharedPlaylistResponsePlaylist {
  title: string;
  description: string;
  images: PlaylistImage[];
}

interface SharedPlaylistResponseAudio {
  guid: string;
  playlistGuid: string;
  audio: {
    guid: string;
    title: string;
    status: AudioStatusType;
    duration: number;
  };
  song: {
    guid: string;
    title: string;
  };
  note: string;
  created: Time;
  updated: Time;
  title?: string;
}

export interface SharedPlaylistResponse {
  response: {
    config?: {
      item: {
        referralId: string;
      };
    };
    share: {
      item: SharedPlaylistResponseShare;
    };
    playlist: {
      item: SharedPlaylistResponsePlaylist;
    };
    playlistAudios: {
      items: SharedPlaylistResponseAudio[];
      _links: {
        getMobileWaveform: Link;
        getDesktopWaveform: Link;
        playAudio: Link;
        downloadAudio?: Link;
      };
    };
  };
}
export type CreateSharedLinkResponse = SingleItemResponse<SharedLink, 'share'>;
export type UpdateSharedLinkResponse = SingleItemResponse<SharedLink, 'share'>;
